import { Typography } from "@material-ui/core";
import { EldFileImportFileDataDto } from "../../../../common/data/service-proxies";
import { BooleanInput, required } from "react-admin";
import { RaDriverPicker } from "../../../common/form/RaDriverPicker";
import { RaVehiclePicker } from "../../../common/form/RaVehiclePicker";

interface Props {
  record?: EldFileImportFileDataDto;
  source?: string;
}

const formatImportDate = (value?: string | null) => {
  if (!value) {
    return null;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime())
    ? null
    : parsedDate.toLocaleDateString();
};

export const EldFileForImport = ({ record, source, ...rest }: Props) => {
  const importDateFrom = formatImportDate(record?.importDateFrom);
  const importDateTo = formatImportDate(record?.importDateTo);

  return (
    <div className="border border-card-border rounded p-3 hover:border-element-fill-9 transition-base">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <Typography variant="body2">{record?.fileName}</Typography>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="w-[1px] h-5 bg-element-fill-1" />
            <BooleanInput
              source={`${source}.overwriteEvents`}
              label="Overwrite"
            />
          </div>
        </div>

        <p className="">
          {record?.suggestedDriverFullName ?? "Unknown name"};{" "}
          {record?.suggestedLicenseNumber ?? "Unknown license number"};{" "}
          {record?.suggestedState ?? "Unknown state"}{" "}
        </p>

        {importDateFrom && importDateTo ? (
          <Typography variant="body2">
            Import period: {importDateFrom} - {importDateTo}
          </Typography>
        ) : null}

        <div>
          <RaDriverPicker
            {...rest}
            source={`${source}.driverId`}
            label="Select a driver"
            validate={required()}
          />
        </div>

        <table>
          <tr>
            <th>Suggested ID</th>
            <th>Suggested VIN</th>
            <th>Selected vehicle</th>
          </tr>
          {record?.vehicles?.map((x, idx) => (
            <tr>
              <td>{x.suggestedName}</td>
              <td>{x.suggestedVin}</td>
              <td>
                <div>
                  <RaVehiclePicker
                    {...rest}
                    source={`${source}.vehicles[${idx}].vehicleId`}
                    label="Pick a vehicle"
                    style={{ width: "100%" }}
                  />
                </div>
              </td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};
